import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { AboutDhadukFamilyComponent } from './about-dhaduk-family/about-dhaduk-family.component';
import { ProfileComponent } from './profile/profile.component';
import { MasterComponent } from './master/master.component';
import { AuthGuard } from './service/auth.guard';
import { NotificationComponent } from './notification/notification.component';
import { PrivacyPolicyComponent } from './auth/privacy-policy/privacy-policy.component';
import { DelectAcountDummyComponent } from './auth/delect-acount-dummy/delect-acount-dummy.component';
import { QrScannerComponent } from './qr-scanner/qr-scanner.component';
import { EventComponent } from './event/event.component';
import { AddEditEventComponent } from './event/add-edit-event/add-edit-event.component';
import { SubEventComponent } from './sub-event/sub-event.component';
import { AddEditSubEventComponent } from './sub-event/add-edit-sub-event/add-edit-sub-event.component';
import { InvitaionPresentmMemebrComponent } from './sub-event/invitaion-presentm-memebr/invitaion-presentm-memebr.component';
import { SendInvitationComponent } from './sub-event/send-invitation/send-invitation.component';
import { EventDonorListComponent } from './sub-event/event-donor-list/event-donor-list.component';
import { AddEventDonorComponent } from './sub-event/event-donor-list/add-event-donor/add-event-donor.component';
import { MenunalInvitationComponent } from './sub-event/menunal-invitation/menunal-invitation.component';
import { ContactListComponent } from './contact-us/contact-list/contact-list.component';
import { EventDonorComponent } from './event-donor/event-donor.component';
import { SubEventDonorComponent } from './event-donor/sub-event-donor/sub-event-donor.component';
import { EventDonorMenulistComponent } from './event-donor/event-donor-menulist/event-donor-menulist.component';
import { NotificationListComponent } from './notification/notification-list/notification-list.component';


const routes: Routes = [
  { path: '', component: DashboardComponent },
  // { path: '', redirectTo: '/auth/flash-screen', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'committee', canActivate: [AuthGuard],
    loadChildren: () => import('./committee/committee.module').then((m) => m.CommitteeModule)
  },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'contact-list', component: ContactListComponent },
  { path: 'jobs',  canActivate: [AuthGuard],
    loadChildren: () => import('./jobs/jobs.module').then((m) => m.JobsModule)
  },
  { path: 'city',  canActivate: [AuthGuard],
    loadChildren: () => import('./city/city.module').then((m) => m.CityModule)
  },
  { path: 'auth', 
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule)
  },
  { path: 'about-dhaduk-family', canActivate: [AuthGuard], component: AboutDhadukFamilyComponent },
  { path: 'student-results',  canActivate: [AuthGuard],
    loadChildren: () => import('./student-result/student-result.module').then((m) => m.StudentResultModule)
  },
  { path: 'profile/:memberId/:action/:page', canActivate: [AuthGuard], component: ProfileComponent },
  { path: 'donor', canActivate: [AuthGuard],
    loadChildren: () => import('./donor/donor.module').then((m) => m.DonorModule)
  },
  { path: 'memory', canActivate: [AuthGuard],
    loadChildren: () => import('./memory/memory.module').then((m) => m.MemoryModule)
  },
  { path: 'NRI', canActivate: [AuthGuard],
    loadChildren: () => import('./NRI/nri.module').then((m) => m.NRIModule)
  },
  { path: 'master', canActivate: [AuthGuard], component: MasterComponent },
  { path: 'notification',canActivate: [AuthGuard], component: NotificationComponent },
  { path: 'notification-list',canActivate: [AuthGuard], component: NotificationListComponent },

  { path: 'business', canActivate: [AuthGuard],
    loadChildren: () => import('./business/business.module').then((m) => m.BusinessModule)
  },
  { path: 'doctor', canActivate: [AuthGuard],
    loadChildren: () => import('./doctor/doctor.module').then((m) => m.DoctorModule)
  },
  { path: 'reminder', canActivate: [AuthGuard],
    loadChildren: () => import('./reminder/reminder.module').then((m) => m.ReminderModule)
  },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'delete-account', component: DelectAcountDummyComponent },
  { path: 'qr-scanner/:sub_event_id', component: QrScannerComponent },
  { path: 'event', component: EventComponent },
  { path: 'add-edit-event/:action', component: AddEditEventComponent },
  { path: 'sub-event/:event_id', component: SubEventComponent },
  { path: 'add-edit-sub-event/:action/:event_id', component: AddEditSubEventComponent },
  { path: 'invitation-present-member/:sub_event_id/:flag', component: InvitaionPresentmMemebrComponent },
  { path: 'menunal-invitation-present-member/:sub_event_id', component: MenunalInvitationComponent },
  { path: 'send-invitation/:sub_event_id', component: SendInvitationComponent },
  { path: 'event-donor/:sub_event_id', component: EventDonorListComponent },
  { path: 'add-event-donor/:sub_event_id', component: AddEventDonorComponent },
  { path: 'event-donor', component: EventDonorComponent },
  { path: 'sub-event-donor/:event_id', component: SubEventDonorComponent },
  { path: 'event-donor-list/:sub_event_id', component: EventDonorMenulistComponent },
  { path: 'user-post',  canActivate: [AuthGuard],
    loadChildren: () => import('./user-post/user-post.module').then((m) => m.UserPostModule)
  },  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
